<template>
	<div
		id="app"
		:class="{
			noscroll: this.$route.meta.panel,
			'sitemap-on': showSitemap,
		}"
	>
		<Ticker v-if="showTicker" />

		<div
			id="top-bar"
			class="sticky z2"
			:class="{ 'z4 nobg': showSitemap }"
			:style="topBarStyle"
		>

			<div
				id="hamburger"
				class="icon pointer z4 hide-print"
				@click="UPDATE_SITEMAP()"
			>
				<img v-if="!showSitemap" src="@/assets/icon-hamburger.svg" alt="" />
				<transition name="rotate-fade">
					<img v-if="showSitemap" src="@/assets/icon-close.svg" alt="" />
				</transition>
			</div>
			<transition name="fade">
				<site-map v-if="showSitemap" @close="hideSitemap"></site-map>
			</transition>

			<div class="flex gap-3 md:gap-6 md:items-baseline" id="search-donate">
				<router-link 
					:class="{ 'hidden xl:block': !showLogo() }"
					class="uppercase"
					id="donate-button"
					:to="{ name: 'Donate' }"
				>

					Support <span class="hidden md:inline">Us</span>
				</router-link>
				<div
					id="search-button"
					class="hover-red pointer z4 hide-print"
					@click="UPDATE_SHOW_SEARCH()"
				>					
					<div class="xs-hide flex items-center">
					  <span class="caps">Search</span>
					</div>
					<img
						class="search-icon sm-hide md-hide lg-hide"
						height="22"
						width="22"
						src="@/assets/icon-search.svg"
					/>
				</div>
			</div>
		</div>

		<Search v-show="showSearch" :showSearch="showSearch"></Search>

		<div
			v-if="showLogo()"
			class="logo-wrapper center mx-auto z1 flex items-center justify-around relative col-12"
		>
			<router-link :to="{ name: 'Investigations' }">
				<img
					class="logo"
					src="/forensic-architecture-logo.svg"
					alt="Forensic Architecture Logo"
				/>
			</router-link>
		</div>

		<Menu></Menu>

		<video-player></video-player>

		<Map v-if="showMap"></Map>

		<router-view />
		<router-view name="footer"></router-view>
	</div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Menu from "@/components/Menu";
import SiteMap from "@/components/SiteMap";
import Map from "@/components/Map";
import Search from "@/components/Search";
import VideoPlayer from "@/components/VideoPlayer";
import Ticker from "@/components/Ticker";

export default {
	name: "app",

	metaInfo: {
		title: "Investigations",
		titleTemplate: "%s ← Forensic Architecture",
	},

	data() {
		return {
			aboutLine: "",
		};
	},

	components: {
		Map,
		Menu,
		Search,
		SiteMap,
		VideoPlayer,
		Ticker,
	},

	computed: {
		...mapState([
			"aboutLines",
			"showMap",
			"showSearch",
			"showSitemap",
			"investigations",
			"searchQuery",
			"showSitemap",
			"subdomainBgColor",
		]),
		showTicker() {
			return this.$route.name === "Investigations";
		},
		topBarStyle() {
			return {
				backgroundColor: this.subdomainBgColor || "var(--col-light)",
			};
		},
	},

	methods: {
		...mapMutations(["UPDATE_SHOW_SEARCH", "UPDATE_SITEMAP"]),
		hideSearch() {
			this.$store.commit("UPDATE_SHOW_SEARCH", "hide");
		},
		hideSitemap() {
			this.$store.commit("UPDATE_SITEMAP", "hide");
		},
		updateAboutLine() {
			this.aboutLine =
				this.aboutLines[
					Math.floor(Math.random() * this.aboutLines.length)
				].text;
		},
		showLogo() {
			return this.$route.meta.logo;
		},
		handleScroll() {
			const topBar = document.getElementById("top-bar");
			if (!topBar) return;
			if (window.scrollY > 50) {
				topBar.classList.add("pinned");
			} else {
				topBar.classList.remove("pinned");
			}
		}
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	beforeUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	},

	watch: {
		$route(to, from) {
			this.hideSearch();
			if (to.name !== "Subdomain") {
				this.$store.commit("SET_SUBDOMAIN_BG_COLOR", null);
			}
		},
		aboutLines() {
			this.updateAboutLine();
		},
	},
};
</script>

<style>
@import "css/app.css";


#top-bar {
	background: var(--col-light);
	height: 46px;

	&.nobg {
		background: transparent;
	}
}

@media (--phone) {
	#top-bar.pinned #donate-button {
		display: none;
	}
}

#donate-button {
	color: var(--red);
}

#hamburger {
	z-index: 9999;
	position: absolute;
	padding: 0.5em;
	top: 0.5em;
	left: 0.5em;
	transform: scale3d(1, 1, 1);
	transition: transform 0.1s ease-out;
}

#search-donate {
	position: absolute;
	padding: 0.5em;
	top: 0.45rem;
	right: 0.5em;
	
	z-index: 1000;
}

#search-button {
	transition: transform 0.2s ease-out;
}

.search-icon {
	height: 22px;
	width: 22px;
	margin-top: -0.1em;
}

.sitemap-on {
	#hamburger {
		position: fixed;
	}
}
</style>
